// 原始键值映射关系
export const originalKeyMapping = [
  { label: "1", value: 2 },
  { label: "2", value: 3 },
  { label: "3", value: 4 },
  { label: "4", value: 5 },
  { label: "5", value: 6 },
  { label: "6", value: 7 },
  { label: "7", value: 8 },
  { label: "8", value: 9 },
  { label: "9", value: 10 },
  { label: "0", value: 11 },
  { label: ".", value: 52 },
  { label: "F1", value: 59 },
  { label: "F2", value: 60 },
  { label: "F3", value: 61 },
  { label: "F4", value: 62 },
  { label: "F5", value: 63 },
  { label: "F6", value: 64 },
  { label: "F7", value: 65 },
  { label: "F8", value: 66 },
  { label: "F9", value: 67 },
  { label: "F10", value: 68 },
  { label: "F11", value: 87 },
  { label: "F12", value: 88 },
  { label: "＜", value: 105 }, //左
  { label: "∧", value: 103 }, //上
  { label: "∨", value: 108 }, //下
  { label: "＞", value: 106 }, //右
  { label: "☼-", value: 224 }, //亮度-
  { label: "☼+", value: 225 }, //亮度+
  { label: "＜——", value: 14 }, //删除键
  { label: "︺", value: 57 }, //空格键
  { label: "LSCAN", value: 248 }, //左扫描键
  { label: "RSCAN", value: 249 }, //右扫描键
  { label: "SCAN", value: 250 }, //中间扫描键
  { label: "P1", value: 513 },
  { label: "P2", value: 514 },
  { label: "ESC", value: 1 },
  { label: "TAB", value: 15 },
  { label: "ENTER", value: 28 },
  { label: "CTRL", value: 29 },
  { label: "SHIFT", value: 42 },
  { label: "ALT", value: 56 },
  { label: "VOL+", value: 115 }, //音量+
  { label: "VOL-", value: 114 }, //音量-
  { label: "A", value: 30 },
  { label: "B", value: 48 },
  { label: "C", value: 46 },
  { label: "D", value: 32 },
  { label: "E", value: 18 },
  { label: "F", value: 33 },
  { label: "G", value: 34 },
  { label: "H", value: 35 },
  { label: "I", value: 23 },
  { label: "J", value: 36 },
  { label: "K", value: 37 },
  { label: "L", value: 38 },
  { label: "M", value: 50 },
  { label: "N", value: 49 },
  { label: "O", value: 24 },
  { label: "P", value: 25 },
  { label: "Q", value: 16 },
  { label: "R", value: 19 },
  { label: "S", value: 31 },
  { label: "T", value: 20 },
  { label: "U", value: 22 },
  { label: "V", value: 47 },
  { label: "W", value: 17 },
  { label: "X", value: 45 },
  { label: "Y", value: 21 },
  { label: "Z", value: 44 },
];

// 目标键值映射关系
export const targetKeyMapping = [
  { label: "UNKNOWN", value: 0 },
  { label: "SOFT_LEFT", value: 1 },
  { label: "SOFT_RIGHT", value: 2 },
  { label: "HOME", value: 3 },
  { label: "BACK", value: 4 },
  { label: "CALL", value: 5 },
  { label: "ENDCALL", value: 6 },
  { label: "0", value: 7 },
  { label: "1", value: 8 },
  { label: "2", value: 9 },
  { label: "3", value: 10 },
  { label: "4", value: 11 },
  { label: "5", value: 12 },
  { label: "6", value: 13 },
  { label: "7", value: 14 },
  { label: "8", value: 15 },
  { label: "9", value: 16 },
  { label: "STAR", value: 17 },
  { label: "POUND", value: 18 },
  { label: "DPAD_UP", value: 19 },
  { label: "DPAD_DOWN", value: 20 },
  { label: "DPAD_LEFT", value: 21 },
  { label: "DPAD_RIGHT", value: 22 },
  { label: "DPAD_CENTER", value: 23 },
  { label: "VOLUME_UP", value: 24 },
  { label: "VOLUME_DOWN", value: 25 },
  { label: "POWER", value: 26 },
  { label: "CAMERA", value: 27 },
  { label: "CLEAR", value: 28 },
  { label: "A", value: 29 },
  { label: "B", value: 30 },
  { label: "C", value: 31 },
  { label: "D", value: 32 },
  { label: "E", value: 33 },
  { label: "F", value: 34 },
  { label: "G", value: 35 },
  { label: "H", value: 36 },
  { label: "I", value: 37 },
  { label: "J", value: 38 },
  { label: "K", value: 39 },
  { label: "L", value: 40 },
  { label: "M", value: 41 },
  { label: "N", value: 42 },
  { label: "O", value: 43 },
  { label: "P", value: 44 },
  { label: "Q", value: 45 },
  { label: "R", value: 46 },
  { label: "S", value: 47 },
  { label: "T", value: 48 },
  { label: "U", value: 49 },
  { label: "V", value: 50 },
  { label: "W", value: 51 },
  { label: "X", value: 52 },
  { label: "Y", value: 53 },
  { label: "Z", value: 54 },
  { label: "COMMA", value: 55 },
  { label: "PERIOD", value: 56 },
  { label: "ALT_LEFT", value: 57 },
  { label: "ALT_RIGHT", value: 58 },
  { label: "SHIFT_LEFT", value: 59 },
  { label: "SHIFT_RIGHT", value: 60 },
  { label: "TAB", value: 61 },
  { label: "SPACE", value: 62 },
  { label: "SYM", value: 63 },
  { label: "EXPLORER", value: 64 },
  { label: "ENVELOPE", value: 65 },
  { label: "ENTER", value: 66 },
  { label: "DEL", value: 67 },
  { label: "GRAVE", value: 68 },
  { label: "MINUS", value: 69 },
  { label: "EQUALS", value: 70 },
  { label: "LEFT_BRACKET", value: 71 },
  { label: "RIGHT_BRACKET", value: 72 },
  { label: "BACKSLASH", value: 73 },
  { label: "SEMICOLON", value: 74 },
  { label: "APOSTROPHE", value: 75 },
  { label: "SLASH", value: 76 },
  { label: "AT", value: 77 },
  { label: "NUM", value: 78 },
  { label: "HEADSETHOOK", value: 79 },
  { label: "FOCUS", value: 80 }, // *Camera* focus
  { label: "PLUS", value: 81 },
  { label: "MENU", value: 82 },
  { label: "NOTIFICATION", value: 83 },
  { label: "SEARCH", value: 84 },
  { label: "MEDIA_PLAY_PAUSE", value: 85 },
  { label: "MEDIA_STOP", value: 86 },
  { label: "MEDIA_NEXT", value: 87 },
  { label: "MEDIA_PREVIOUS", value: 88 },
  { label: "MEDIA_REWIND", value: 89 },
  { label: "MEDIA_FAST_FORWARD", value: 90 },
  { label: "MUTE", value: 91 },
  { label: "PAGE_UP", value: 92 },
  { label: "PAGE_DOWN", value: 93 },
  { label: "PICTSYMBOLS", value: 94 }, // switch symbol-sets (Emoji,Kao-moji)
  { label: "SWITCH_CHARSET", value: 95 }, // switch char-sets (Kanji,Katakana)
  { label: "BUTTON_A", value: 96 },
  { label: "BUTTON_B", value: 97 },
  { label: "BUTTON_C", value: 98 },
  { label: "BUTTON_X", value: 99 },
  { label: "BUTTON_Y", value: 100 },
  { label: "BUTTON_Z", value: 101 },
  { label: "BUTTON_L1", value: 102 },
  { label: "BUTTON_R1", value: 103 },
  { label: "BUTTON_L2", value: 104 },
  { label: "BUTTON_R2", value: 105 },
  { label: "BUTTON_THUMBL", value: 106 },
  { label: "BUTTON_THUMBR", value: 107 },
  { label: "BUTTON_START", value: 108 },
  { label: "BUTTON_SELECT", value: 109 },
  { label: "BUTTON_MODE", value: 110 },
  { label: "ESCAPE", value: 111 },
  { label: "FORWARD_DEL", value: 112 },
  { label: "CTRL_LEFT", value: 113 },
  { label: "CTRL_RIGHT", value: 114 },
  { label: "CAPS_LOCK", value: 115 },
  { label: "SCROLL_LOCK", value: 116 },
  { label: "META_LEFT", value: 117 },
  { label: "META_RIGHT", value: 118 },
  { label: "FUNCTION", value: 119 },
  { label: "SYSRQ", value: 120 },
  { label: "BREAK", value: 121 },
  { label: "MOVE_HOME", value: 122 },
  { label: "MOVE_END", value: 123 },
  { label: "INSERT", value: 124 },
  { label: "FORWARD", value: 125 },
  { label: "MEDIA_PLAY", value: 126 },
  { label: "MEDIA_PAUSE", value: 127 },
  { label: "MEDIA_CLOSE", value: 128 },
  { label: "MEDIA_EJECT", value: 129 },
  { label: "MEDIA_RECORD", value: 130 },
  { label: "F1", value: 131 },
  { label: "F2", value: 132 },
  { label: "F3", value: 133 },
  { label: "F4", value: 134 },
  { label: "F5", value: 135 },
  { label: "F6", value: 136 },
  { label: "F7", value: 137 },
  { label: "F8", value: 138 },
  { label: "F9", value: 139 },
  { label: "F10", value: 140 },
  { label: "F11", value: 141 },
  { label: "F12", value: 142 },
  { label: "NUM_LOCK", value: 143 },
  { label: "NUMPAD_0", value: 144 },
  { label: "NUMPAD_1", value: 145 },
  { label: "NUMPAD_2", value: 146 },
  { label: "NUMPAD_3", value: 147 },
  { label: "NUMPAD_4", value: 148 },
  { label: "NUMPAD_5", value: 149 },
  { label: "NUMPAD_6", value: 150 },
  { label: "NUMPAD_7", value: 151 },
  { label: "NUMPAD_8", value: 152 },
  { label: "NUMPAD_9", value: 153 },
  { label: "NUMPAD_DIVIDE", value: 154 },
  { label: "NUMPAD_MULTIPLY", value: 155 },
  { label: "NUMPAD_SUBTRACT", value: 156 },
  { label: "NUMPAD_ADD", value: 157 },
  { label: "NUMPAD_DOT", value: 158 },
  { label: "NUMPAD_COMMA", value: 159 },
  { label: "NUMPAD_ENTER", value: 160 },
  { label: "NUMPAD_EQUALS", value: 161 },
  { label: "NUMPAD_LEFT_PAREN", value: 162 },
  { label: "NUMPAD_RIGHT_PAREN", value: 163 },
  { label: "VOLUME_MUTE", value: 164 },
  { label: "INFO", value: 165 },
  { label: "CHANNEL_UP", value: 166 },
  { label: "CHANNEL_DOWN", value: 167 },
  { label: "ZOOM_IN", value: 168 },
  { label: "ZOOM_OUT", value: 169 },
  { label: "TV", value: 170 },
  { label: "WINDOW", value: 171 },
  { label: "GUIDE", value: 172 },
  { label: "DVR", value: 173 },
  { label: "BOOKMARK", value: 174 },
  { label: "CAPTIONS", value: 175 },
  { label: "SETTINGS", value: 176 },
  { label: "TV_POWER", value: 177 },
  { label: "TV_INPUT", value: 178 },
  { label: "STB_POWER", value: 179 },
  { label: "STB_INPUT", value: 180 },
  { label: "AVR_POWER", value: 181 },
  { label: "AVR_INPUT", value: 182 },
  { label: "PROG_RED", value: 183 },
  { label: "PROG_GREEN", value: 184 },
  { label: "PROG_YELLOW", value: 185 },
  { label: "PROG_BLUE", value: 186 },
  { label: "APP_SWITCH", value: 187 },
  { label: "BUTTON_1", value: 188 },
  { label: "BUTTON_2", value: 189 },
  { label: "BUTTON_3", value: 190 },
  { label: "BUTTON_4", value: 191 },
  { label: "BUTTON_5", value: 192 },
  { label: "BUTTON_6", value: 193 },
  { label: "BUTTON_7", value: 194 },
  { label: "BUTTON_8", value: 195 },
  { label: "BUTTON_9", value: 196 },
  { label: "BUTTON_10", value: 197 },
  { label: "BUTTON_11", value: 198 },
  { label: "BUTTON_12", value: 199 },
  { label: "BUTTON_13", value: 200 },
  { label: "BUTTON_14", value: 201 },
  { label: "BUTTON_15", value: 202 },
  { label: "BUTTON_16", value: 203 },
  { label: "LANGUAGE_SWITCH", value: 204 },
  { label: "MANNER_MODE", value: 205 },
  { label: "3D_MODE", value: 206 },
  { label: "CONTACTS", value: 207 },
  { label: "CALENDAR", value: 208 },
  { label: "MUSIC", value: 209 },
  { label: "CALCULATOR", value: 210 },
  { label: "ZENKAKU_HANKAKU", value: 211 },
  { label: "EISU", value: 212 },
  { label: "MUHENKAN", value: 213 },
  { label: "HENKAN", value: 214 },
  { label: "KATAKANA_HIRAGANA", value: 215 },
  { label: "YEN", value: 216 },
  { label: "RO", value: 217 },
  { label: "KANA", value: 218 },
  { label: "ASSIST", value: 219 },
  { label: "BRIGHTNESS_DOWN", value: 220 },
  { label: "BRIGHTNESS_UP", value: 221 },
  { label: "MEDIA_AUDIO_TRACK", value: 222 },
  { label: "SLEEP", value: 223 },
  { label: "WAKEUP", value: 224 },
  { label: "PAIRING", value: 225 },
  { label: "MEDIA_TOP_MENU", value: 226 },
  { label: "11", value: 227 },
  { label: "12", value: 228 },
  { label: "LAST_CHANNEL", value: 229 },
  { label: "TV_DATA_SERVICE", value: 230 },
  { label: "VOICE_ASSIST", value: 231 },
  { label: "TV_RADIO_SERVICE", value: 232 },
  { label: "TV_TELETEXT", value: 233 },
  { label: "TV_NUMBER_ENTRY", value: 234 },
  { label: "TV_TERRESTRIAL_ANALOG", value: 235 },
  { label: "TV_TERRESTRIAL_DIGITAL", value: 236 },
  { label: "TV_SATELLITE", value: 237 },
  { label: "TV_SATELLITE_BS", value: 238 },
  { label: "TV_SATELLITE_CS", value: 239 },
  { label: "TV_SATELLITE_SERVICE", value: 240 },
  { label: "TV_NETWORK", value: 241 },
  { label: "TV_ANTENNA_CABLE", value: 242 },
  { label: "TV_INPUT_HDMI_1", value: 243 },
  { label: "TV_INPUT_HDMI_2", value: 244 },
  { label: "TV_INPUT_HDMI_3", value: 245 },
  { label: "TV_INPUT_HDMI_4", value: 246 },
  { label: "TV_INPUT_COMPOSITE_1", value: 247 },
  { label: "TV_INPUT_COMPOSITE_2", value: 248 },
  { label: "TV_INPUT_COMPONENT_1", value: 249 },
  { label: "TV_INPUT_COMPONENT_2", value: 250 },
  { label: "TV_INPUT_VGA_1", value: 251 },
  { label: "TV_AUDIO_DESCRIPTION", value: 252 },
  { label: "TV_AUDIO_DESCRIPTION_MIX_UP", value: 253 },
  { label: "TV_AUDIO_DESCRIPTION_MIX_DOWN", value: 254 },
  { label: "TV_ZOOM_MODE", value: 255 },
  { label: "TV_CONTENTS_MENU", value: 256 },
  { label: "TV_MEDIA_CONTEXT_MENU", value: 257 },
  { label: "TV_TIMER_PROGRAMMING", value: 258 },
  { label: "HELP", value: 259 },
  { label: "NAVIGATE_PREVIOUS", value: 260 },
  { label: "NAVIGATE_NEXT", value: 261 },
  { label: "NAVIGATE_IN", value: 262 },
  { label: "NAVIGATE_OUT", value: 263 },
  { label: "STEM_PRIMARY", value: 264 },
  { label: "STEM_1", value: 265 },
  { label: "STEM_2", value: 266 },
  { label: "STEM_3", value: 267 },
  { label: "DPAD_UP_LEFT", value: 268 },
  { label: "DPAD_DOWN_LEFT", value: 269 },
  { label: "DPAD_UP_RIGHT", value: 270 },
  { label: "DPAD_DOWN_RIGHT", value: 271 },
  { label: "MEDIA_SKIP_FORWARD", value: 272 },
  { label: "MEDIA_SKIP_BACKWARD", value: 273 },
  { label: "MEDIA_STEP_FORWARD", value: 274 },
  { label: "MEDIA_STEP_BACKWARD", value: 275 },
  { label: "SOFT_SLEEP", value: 276 },
  { label: "CUT", value: 277 },
  { label: "COPY", value: 278 },
  { label: "PASTE", value: 279 },
  { label: "SYSTEM_NAVIGATION_UP", value: 280 },
  { label: "SYSTEM_NAVIGATION_DOWN", value: 281 },
  { label: "SYSTEM_NAVIGATION_LEFT", value: 282 },
  { label: "SYSTEM_NAVIGATION_RIGHT", value: 283 },
];